const {
	REACT_APP_WEBINAR_EVENT_OPENED_URL,
	REACT_APP_WEBINAR_EVENT_PRESSED_PLAY,
	REACT_APP_WEBINAR_EVENT_WATCHED_25,
	REACT_APP_WEBINAR_EVENT_WATCHED_50,
	REACT_APP_WEBINAR_EVENT_WATCHED_75,
	REACT_APP_WEBINAR_EVENT_WATCHED_85,
	REACT_APP_WEBINAR_EVENT_WATCHED_100,
	REACT_APP_FB_PIXEL_TRACK_EVENT_VIEW,
	REACT_APP_FB_PIXEL_TRACK_EVENT_PLAY,
	REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_25,
	REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_50,
	REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_75,
	REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_85,
	REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_100,
} = process.env


export const WEBINAR_EVENT_OPENED_URL = REACT_APP_WEBINAR_EVENT_OPENED_URL
export const WEBINAR_EVENT_PRESSED_PLAY = REACT_APP_WEBINAR_EVENT_PRESSED_PLAY
export const WEBINAR_EVENT_WATCHED_25 = REACT_APP_WEBINAR_EVENT_WATCHED_25
export const WEBINAR_EVENT_WATCHED_50 = REACT_APP_WEBINAR_EVENT_WATCHED_50
export const WEBINAR_EVENT_WATCHED_75 = REACT_APP_WEBINAR_EVENT_WATCHED_75
export const WEBINAR_EVENT_WATCHED_85 = REACT_APP_WEBINAR_EVENT_WATCHED_85
export const WEBINAR_EVENT_WATCHED_100 = REACT_APP_WEBINAR_EVENT_WATCHED_100

export const FB_PIXEL_TRACK_EVENT_VIEW = REACT_APP_FB_PIXEL_TRACK_EVENT_VIEW
export const FB_PIXEL_EVENT_OPENED_URL = REACT_APP_FB_PIXEL_TRACK_EVENT_VIEW
export const FB_PIXEL_EVENT_PRESSED_PLAY = REACT_APP_FB_PIXEL_TRACK_EVENT_PLAY
export const FB_PIXEL_EVENT_WATCHED_25 = REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_25
export const FB_PIXEL_EVENT_WATCHED_50 = REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_50
export const FB_PIXEL_EVENT_WATCHED_75 = REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_75
export const FB_PIXEL_EVENT_WATCHED_85 = REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_85
export const FB_PIXEL_EVENT_WATCHED_100 = REACT_APP_FB_PIXEL_TRACK_EVENT_WATCHED_100

export const EVENTS_MAPPING = {
	[FB_PIXEL_EVENT_OPENED_URL]: WEBINAR_EVENT_OPENED_URL,
	[FB_PIXEL_EVENT_PRESSED_PLAY]: WEBINAR_EVENT_PRESSED_PLAY,
	[FB_PIXEL_EVENT_WATCHED_25]: WEBINAR_EVENT_WATCHED_25,
	[FB_PIXEL_EVENT_WATCHED_50]: WEBINAR_EVENT_WATCHED_50,
	[FB_PIXEL_EVENT_WATCHED_75]: WEBINAR_EVENT_WATCHED_75,
	[FB_PIXEL_EVENT_WATCHED_85]: WEBINAR_EVENT_WATCHED_85,
	[FB_PIXEL_EVENT_WATCHED_100]: WEBINAR_EVENT_WATCHED_100,
}